/*!
 * vue-bem v0.10.20 
 * (c) 2023 Alex Tkachenko
 * Released under the MIT License.
 */
import { createBlockNameGenerator, createStateGenerator } from '@aspectus/bem';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function getContext(vnode) {
  return vnode.fnContext || vnode.context;
}

function _getBlockName(options, key) {
  return options[key] || options.blockName || options.block || options.name;
}

var Directive =
/*#__PURE__*/
function () {
  function Directive(config) {
    _classCallCheck(this, Directive);

    this.config = config;
    this.generator = this.getGenerator(config);
    this.bind = this.bind.bind(this);
    this.update = this.update.bind(this);
    this.unbind = this.unbind.bind(this);
  }

  _createClass(Directive, [{
    key: "addClasses",
    value: function addClasses(el, classes) {
      el.classList.add.apply(el.classList, classes);
    }
  }, {
    key: "removeClasses",
    value: function removeClasses(el, classes) {
      el.classList.remove.apply(el.classList, classes);
    }
  }, {
    key: "bind",
    value: function bind() {}
  }, {
    key: "update",
    value: function update() {}
  }, {
    key: "unbind",
    value: function unbind() {}
  }]);

  return Directive;
}();
var BlockDirective =
/*#__PURE__*/
function (_Directive) {
  _inherits(BlockDirective, _Directive);

  function BlockDirective() {
    _classCallCheck(this, BlockDirective);

    return _possibleConstructorReturn(this, _getPrototypeOf(BlockDirective).apply(this, arguments));
  }

  _createClass(BlockDirective, [{
    key: "getGenerator",
    value: function getGenerator(config) {
      return createBlockNameGenerator(config);
    }
  }, {
    key: "getBlockName",
    value: function getBlockName(binding, vnode) {
      return binding.arg || _getBlockName(getContext(vnode).$options, this.config.blockNameKey);
    }
  }, {
    key: "getElementName",
    value: function getElementName(binding) {
      /* eslint-disable no-restricted-syntax, prefer-destructuring, no-prototype-builtins */
      var modifiers = binding.modifiers;

      if (modifiers) {
        for (var key in modifiers) {
          if (modifiers.hasOwnProperty(key)) {
            return key;
          }
        }
      }

      return undefined;
    }
  }, {
    key: "bind",
    value: function bind(el, binding, vnode) {
      var blockName = this.getBlockName(binding, vnode);
      if (!blockName) return;
      this.addClasses(el, this.generator(blockName, this.getElementName(binding), binding.value));
    }
  }, {
    key: "update",
    value: function update(el, binding, vnode) {
      var blockName = this.getBlockName(binding, vnode);
      if (!blockName) return;
      this.removeClasses(el, this.generator(blockName, this.getElementName(binding), binding.oldValue));
      this.addClasses(el, this.generator(blockName, this.getElementName(binding), binding.value));
    }
  }]);

  return BlockDirective;
}(Directive);
var BlockDirectiveUnbindable =
/*#__PURE__*/
function (_BlockDirective) {
  _inherits(BlockDirectiveUnbindable, _BlockDirective);

  function BlockDirectiveUnbindable() {
    _classCallCheck(this, BlockDirectiveUnbindable);

    return _possibleConstructorReturn(this, _getPrototypeOf(BlockDirectiveUnbindable).apply(this, arguments));
  }

  _createClass(BlockDirectiveUnbindable, [{
    key: "unbind",
    value: function unbind(el, binding, vnode) {
      var blockName = this.getBlockName(binding, vnode);
      if (!blockName) return;
      this.removeClasses(el, this.generator(blockName, this.getElementName(binding), binding.value));
    }
  }]);

  return BlockDirectiveUnbindable;
}(BlockDirective);
var StateDirective =
/*#__PURE__*/
function (_Directive2) {
  _inherits(StateDirective, _Directive2);

  function StateDirective() {
    _classCallCheck(this, StateDirective);

    return _possibleConstructorReturn(this, _getPrototypeOf(StateDirective).apply(this, arguments));
  }

  _createClass(StateDirective, [{
    key: "getGenerator",
    value: function getGenerator(config) {
      return createStateGenerator(config);
    }
  }, {
    key: "bind",
    value: function bind(el, binding) {
      this.addClasses(el, this.generator(Object.assign({}, binding.modifiers, binding.value)));
    }
  }, {
    key: "update",
    value: function update(el, binding) {
      this.removeClasses(el, this.generator(binding.oldValue));
      this.addClasses(el, this.generator(binding.value));
    }
  }]);

  return StateDirective;
}(Directive);
var StateDirectiveUnbindable =
/*#__PURE__*/
function (_StateDirective) {
  _inherits(StateDirectiveUnbindable, _StateDirective);

  function StateDirectiveUnbindable() {
    _classCallCheck(this, StateDirectiveUnbindable);

    return _possibleConstructorReturn(this, _getPrototypeOf(StateDirectiveUnbindable).apply(this, arguments));
  }

  _createClass(StateDirectiveUnbindable, [{
    key: "unbind",
    value: function unbind(el, binding) {
      this.removeClasses(el, this.generator(Object.assign({}, binding.modifiers, binding.value)));
    }
  }]);

  return StateDirectiveUnbindable;
}(StateDirective);

function install(Vue) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$blockNameKey = _ref.blockNameKey,
      blockNameKey = _ref$blockNameKey === void 0 ? 'name' : _ref$blockNameKey,
      _ref$block = _ref.block,
      block = _ref$block === void 0 ? 'bem' : _ref$block,
      _ref$state = _ref.state,
      state = _ref$state === void 0 ? 'state' : _ref$state,
      _ref$naming = _ref.naming,
      naming = _ref$naming === void 0 ? {} : _ref$naming,
      _ref$unbindable = _ref.unbindable,
      unbindable = _ref$unbindable === void 0 ? false : _ref$unbindable;

  Vue.directive(block, new (unbindable ? BlockDirectiveUnbindable : BlockDirective)(_objectSpread2({
    blockNameKey: blockNameKey
  }, naming)));
  Vue.directive(state, new (unbindable ? StateDirectiveUnbindable : StateDirective)(naming));
}
var main = {
  install: install
};

export default main;
export { BlockDirective, BlockDirectiveUnbindable, Directive, StateDirective, StateDirectiveUnbindable, install };
